// extracted by mini-css-extract-plugin
export default {"cookie_button":"cookieButton_cookie_button__pWAPD","sidebar":"cookieButton_sidebar__pEhmZ","selected":"cookieButton_selected__9iRex"};